import type { ApiResponse } from 'models/ApiResponse';

export function wrapAsApiResponse<T>(payload: any): ApiResponse<T> {
  if (payload && typeof payload === 'object' && 'success' in payload && 'data' in payload) {
    return payload as ApiResponse<T>;
  }

  return {
    success: true,
    data: payload as T,
  };
}
